/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_success_login_method_unlinked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login method unlinked.`)
};

const zh_hans1_settings_success_login_method_unlinked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录方式已解绑。`)
};

const zh_hant1_settings_success_login_method_unlinked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已解除綁定登入方式`)
};

const fr_settings_success_login_method_unlinked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Méthode de connexion dissociée.`)
};

const de_settings_success_login_method_unlinked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login-Methode getrennt.`)
};

const ja_settings_success_login_method_unlinked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン方法の連携を解除しました。`)
};

const ko_settings_success_login_method_unlinked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 방법 연결이 해제되었습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_success_login_method_unlinked = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_success_login_method_unlinked(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_success_login_method_unlinked", locale)
	if (locale === "en") return en_settings_success_login_method_unlinked(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_success_login_method_unlinked(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_success_login_method_unlinked(inputs)
	if (locale === "fr") return fr_settings_success_login_method_unlinked(inputs)
	if (locale === "de") return de_settings_success_login_method_unlinked(inputs)
	if (locale === "ja") return ja_settings_success_login_method_unlinked(inputs)
	return ko_settings_success_login_method_unlinked(inputs)
};